<template>
    <div class="section">
        <div class="tabs is-large is-boxed is-toggle">
            <ul>
                <li class="initial" v-bind:class="{ 'is-active': this.bord}"><a @click="bordbooking()">Bordbooking</a></li>
                <li class="initial" v-bind:class="{ 'is-active': this.klubb}"><a @click="klubbkvelder()">Klubbkvelder</a></li>
                <li class="initial" v-bind:class="{ 'is-active': this.medlemmer}"><a @click="medlemsregister()">Medlemsregister</a></li>
            </ul>
        </div>

        <div>            
            <bord v-if="this.bord"></bord>
            <klubbkveld v-if="this.klubb"></klubbkveld>
            <medlemmer v-if="this.medlemmer"></medlemmer>
        </div>

    </div>
</template>

<script>

    export default {
        name: "Secure",
        data() {
            return {
                bord: true,
                klubb: false,
                medlemmer: false
            }
        },
        methods: {
            bordbooking() {
                this.bord = true;
                this.klubb = false;
                this.medlemmer = false;
            },
            klubbkvelder() {
                this.bord = false;
                this.klubb = true;
                this.medlemmer = false;
            },
            medlemsregister() {
                this.bord = false;
                this.klubb = false;
                this.medlemmer = true;
            }
        }
    }
</script>